import * as AIPurchasePredictionService from './components/AIPurchasePredictionService.css';
import * as AiPredictionFooter from './components/AiPredictionFooter/AiPredictionFooter.css';
export default {
    AIPurchasePredictionService,
    AiPredictionFooter
};
